<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>sync</mat-icon></div>
    <div>
      <span>Sincronizar con Bookcit</span>
      <small class="dlg-hdr__sub">{{ data.conceptName }}</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="cancel()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">

  <ng-container *ngIf="loading">
    <div class="bccs-loading">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading">

    <div *ngIf="error" class="bccs-error">{{ error }}</div>

    <div class="bccs-section-label">Datos del servicio</div>

    <div class="bccs-compare-grid">
      <div class="bccs-col-hdr">
        <mat-icon class="bccs-icon bccs-icon--factu">business</mat-icon>
        <span>Handly</span>
      </div>
      <div class="bccs-col-hdr-mid"></div>
      <div class="bccs-col-hdr">
        <mat-icon class="bccs-icon bccs-icon--bookcit">event_available</mat-icon>
        <span>Bookcit</span>
      </div>

      <!-- Nombre -->
      <div class="bccs-cell">
        <app-input inputType="text" placeholder="Nombre" class="bccs-field" [formControl]="form.get('factuName')"></app-input>
      </div>
      <div class="bccs-arrows">
        <button mat-icon-button class="bccs-arrow-btn" (click)="copyNameToBookit()" title="Copiar a Bookcit"><mat-icon>chevron_right</mat-icon></button>
        <button mat-icon-button class="bccs-arrow-btn" (click)="copyNameFromBookit()" title="Copiar de Bookcit"><mat-icon>chevron_left</mat-icon></button>
      </div>
      <div class="bccs-cell">
        <app-input inputType="text" placeholder="Título en Bookcit" class="bccs-field" [formControl]="form.get('bookitTitle')"></app-input>
      </div>

      <!-- Descripción -->
      <div class="bccs-cell">
        <app-input inputType="text" placeholder="Descripción" class="bccs-field" [formControl]="form.get('factuDescription')"></app-input>
      </div>
      <div class="bccs-arrows">
        <button mat-icon-button class="bccs-arrow-btn" (click)="copyDescToBookit()" title="Copiar a Bookcit"><mat-icon>chevron_right</mat-icon></button>
        <button mat-icon-button class="bccs-arrow-btn" (click)="copyDescFromBookit()" title="Copiar de Bookcit"><mat-icon>chevron_left</mat-icon></button>
      </div>
      <div class="bccs-cell">
        <app-input inputType="text" placeholder="Descripción en Bookcit" class="bccs-field" [formControl]="form.get('bookitDescription')"></app-input>
      </div>

      <!-- Precio -->
      <div class="bccs-cell">
        <mat-form-field appearance="outline" class="bccs-field">
          <mat-label>Precio</mat-label>
          <input matInput type="number" [formControl]="form.get('factuPrice')">
          <span matSuffix class="bccs-euro-suffix">€</span>
        </mat-form-field>
      </div>
      <div class="bccs-arrows">
        <button mat-icon-button class="bccs-arrow-btn" (click)="copyPriceToBookit()" title="Copiar a Bookcit"><mat-icon>chevron_right</mat-icon></button>
        <button mat-icon-button class="bccs-arrow-btn" (click)="copyPriceFromBookit()" title="Copiar de Bookcit"><mat-icon>chevron_left</mat-icon></button>
      </div>
      <div class="bccs-cell">
        <mat-form-field appearance="outline" class="bccs-field">
          <mat-label>Precio en Bookcit</mat-label>
          <input matInput type="number" [formControl]="form.get('bookitPrice')">
          <span matSuffix class="bccs-euro-suffix">€</span>
        </mat-form-field>
      </div>

      <!-- Duración solo Bookcit -->
      <div class="bccs-cell"></div>
      <div class="bccs-arrows"></div>
      <div class="bccs-cell">
        <mat-form-field appearance="outline" class="bccs-field">
          <mat-label>Duración (min)</mat-label>
          <input matInput type="number" [formControl]="form.get('bookitDuration')">
        </mat-form-field>
      </div>
    </div>

    <div class="bccs-section-label">Ubicaciones activas</div>

    <p *ngIf="rows.length === 0" class="bccs-empty">No hay ubicaciones de Bookcit configuradas.</p>

    <div *ngIf="rows.length > 0" class="bccs-locations">
      <mat-checkbox *ngFor="let row of rows" [formControl]="row.checkControl">{{ row.name }}</mat-checkbox>
    </div>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-stroked-button (click)="cancel()" [disabled]="saving">Cancelar</button>
  <button mat-flat-button class="dlg-btn-save" (click)="save()" [disabled]="saving || loading">
    <mat-icon *ngIf="!saving">sync</mat-icon>
    <mat-progress-spinner *ngIf="saving" mode="indeterminate" diameter="18" style="display:inline-block"></mat-progress-spinner>
    <span>{{ saving ? 'Sincronizando...' : 'Sincronizar' }}</span>
  </button>
</mat-dialog-actions>
